import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/tasks';
    import { computed, watch } from 'vue';
    import { useDashboardStore } from '@/stores/dashboard';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import axios from 'axios';
    import CreateTask from './CreateTask.vue';
    import CreateTaskFromTemplate from './CreateTaskFromTemplate.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import HoverInfo from '@/components/HoverInfo.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { Company, SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardTasks',
  props: {
    company: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const props = __props;

    const { t } = useI18n();
    const { hasPermission } = usePermissions();
    const dashboardStore = useDashboardStore();

    const companyId = computed(() => props.company.id);
    const isClient = computed(() => page.props.auth.user.is_client);

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.DASHBOARD_TASKS, companyId],
        queryFn: getTasks,
    });

    async function getTasks() {
        const { data } = await axios.get(route('v2.dashboard.tasks.get'));
        return data.data;
    }

    watch(data, (newVal) => {
        if (newVal) {
            dashboardStore.setTasks(newVal);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageCard, { class: "mb-0 overflow-hidden md:mr-0 md:mb-1.5" }, {
    default: _withCtx(() => [
      _createVNode(DataTable, {
        "table-key": _unref(QueryKey).DASHBOARD_TASKS,
        columns: _unref(columns),
        data: _unref(data),
        loading: _unref(isPending),
        "default-column-visibility": {
                task_responsible_ids: false,
            },
        "default-sorting": [
                {
                    id: 'deadline',
                    desc: false,
                },
            ],
        "default-pagination": {
                pageIndex: 0,
                pageSize: 10,
            },
        "enable-search": false,
        "enable-filters": false
      }, _createSlots({
        title: _withCtx(() => [
          _createVNode(_unref(CardTitle), { class: "flex items-center gap-2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dashboards.tasks_header')) + " ", 1),
              (isClient.value)
                ? (_openBlock(), _createBlock(HoverInfo, {
                    key: 0,
                    content: _unref(t)('dashboards.tasks_help')
                  }, null, 8, ["content"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_CREATE))
          ? {
              name: "actions",
              fn: _withCtx(() => [
                _createVNode(DataTableToolbarActions, { name: "dashboard-tasks" }, {
                  default: _withCtx(() => [
                    _createVNode(CreateTask, { company: _ctx.company }, null, 8, ["company"]),
                    _createVNode(CreateTaskFromTemplate, { company: _ctx.company }, null, 8, ["company"])
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["table-key", "columns", "data", "loading"])
    ]),
    _: 1
  }))
}
}

})